import React, { useState, useEffect } from "react";
import { FiMoreVertical } from "react-icons/fi";
import { var_api } from "../../../constant";

const Column = ({ title, color, apiUrl }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(apiUrl)
      .then((res) => res.json())
      .then((result) => {
        setData(result);
      })
      .catch((err) => console.error("API Error:", err));
  }, [apiUrl]);

  
  const handleMove = async (item) => {
  try {
    const response = await fetch(`${var_api}veemart_instore_pos_billing/update-status/${item.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        status: 2,
      }),
    });

    const result = await response.json();
    console.log("Update Response:", result);

    if (result.success) {
      alert("Package moved successfully!");
      window.location.reload(); // refresh UI
    } else {
      alert("Failed to update status");
    }
  } catch (error) {
    console.error("API Error:", error);
  }
};


  return (
    <div className="column">
      <div className="column-header" style={{ backgroundColor: color }}>
        <span className="column-title">{title}</span>

        <div
          className="menu-wrapper"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu((prev) => !prev);
          }}
        >
          <FiMoreVertical className="menu-icon" />

          {openMenu && (
            <div className="dropdown-menu">
              <ul>
                <li>Sort by</li>
                <li>Import Packages</li>
                <li>Export Packages</li>
                <li>Import Shipments</li>
                <li>Export Shipments</li>
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* RECORDS */}
      {data.length === 0 ? (
        <div className="no-records-box">No Records Found</div>
      ) : (
        <div className="records-list">
          {data.map((item) => (
         <div key={item.id} className="record-card">

  {/* HEADER */}
  <div className="card-header">
    <strong>Bill No: {item.bill_number}</strong>

    <div className="right-actions">
      <span className="date">{item.bill_date_time}</span>
      <button
        className="move-btn"
        onClick={() => handleMove(item)}
      >
        Move
      </button>
    </div>
  </div>

  {/* GRID */}
  <div className="card-grid">
    <div><strong>Customer:</strong> {item.customer_name}</div>
    <div><strong>Mobile:</strong> {item.customer_mobile}</div>
    <div><strong>Total:</strong> ₹{item.grand_total}</div>
    <div><strong>Qty:</strong> {item.total_qty}</div>
  </div>

</div>

          ))}
        </div>
      )}
    </div>
  );
};

export default function PackagesBoard() {
   const warehouse_id = localStorage.getItem("warehouse_id");

  

  return (
    <>
      <style>{`
        .page-container {
          padding: 20px;
          font-family: Arial, sans-serif;
          position: relative;
        }

        .top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .page-title {
          font-size: 22px;
          font-weight: bold;
        }

        .board-container {
          display: flex;
          gap: 20px;
          width: 100%;
          margin-top: 20px;
        }

        .column {
          flex: 1;
          background: #ffffff;
          border: 1px solid #e3e3e3;
          border-radius: 10px;
          min-height: 600px;
          position: relative;
        }

        .column-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 14px 18px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          font-weight: bold;
          font-size: 14px;
          position: relative;
        }

        .menu-wrapper {
          position: relative;
          cursor: pointer;
          z-index: 9999;
        }

        .menu-icon {
          font-size: 18px;
        }

        .dropdown-menu {
          position: absolute;
          right: 0;
          top: 22px;
          width: 170px;
          background: white;
          border: 1px solid #ddd;
          border-radius: 8px;
          box-shadow: 0px 3px 10px rgba(0,0,0,0.15);
          z-index: 10000;
        }

        .dropdown-menu ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .dropdown-menu li {
          padding: 10px 14px;
          font-size: 14px;
          cursor: pointer;
        }

        .dropdown-menu li:hover {
          background: #f3f3f3;
        }

        .no-records-box {
          width: 90%;
          height: 150px;
          margin: 20px auto;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #7a7a7a;
          font-size: 14px;
          background:#fafafa;
        }

       .records-list {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* CARD */
.record-card {
  border: 1px solid #e0e0e0;
  border-left: 5px solid #4a90e2;
  border-radius: 10px;
  padding: 14px 16px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.record-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* HEADER ROW */
.card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.card-header strong {
  font-size: 14px;
}

.card-header .date {
  font-size: 12px;
  color: #666;
}

/* GRID ROWS */
.card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 10px;
}

.card-grid div {
  font-size: 13px;
  color: #333;
}


.card-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.move-btn {
  background: #4a90e2;
  color: white;
  border: none;
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.move-btn:hover {
  background: #357ac8;
}

.right-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.right-actions .date {
  font-size: 12px;
  color: #666;
}


      `}</style>

      <div className="page-container">
        <div className="top-bar">
          <h2 className="page-title">All Packages</h2>
        </div>

        <div className="board-container">
          {/* INPROGRESS */}
          <Column
            title="Inprogress, Not Shipped"
            color="#d9f1fa"
            apiUrl={`${var_api}veemart_instore_pos_billing/inprogress/${warehouse_id}`}
          />

          {/* OUT FOR DELIVERY */}
          <Column
            title="Out for Delivery Packages"
            color="#fdf8c4"
            apiUrl={`${var_api}veemart_instore_pos_billing/outfordelivery/${warehouse_id}`}
          />

          {/* DELIVERED */}
          <Column
            title="Delivered Packages"
            color="#dff5c8"
            apiUrl={`${var_api}veemart_instore_pos_billing/delivered/${warehouse_id}`}
          />
        </div>
      </div>
    </>
  );
}
